import { createComponent } from '@helpers/admin';
import { ComparisonSection } from '@template/blocks/ComparisonSection/component';
import { Input, Select } from '@template/components';

export const ComparisonTable = createComponent({
  label: 'Comparison Table',
  component: ComparisonSection,
  fields: {
    title: {
      label: 'Title',
      type: 'textarea',
    },
    description: {
      label: 'Description',
      type: 'textarea',
    },
    comparisonHeaders: {
      label: 'Comparison Headers',
      type: 'array',
      arrayFields: {
        title: {
          label: 'Title',
          type: 'textarea',
        },
        image: {
          label: 'Image',
          type: 'image',
        },
      },
    },
    comparisons: {
      label: 'Comparisons',
      type: 'array',
      arrayFields: {
        title: {
          label: 'Title',
          type: 'textarea',
        },
        values: {
          label: 'Values',
          type: 'array',
          arrayFields: {
            value: {
              label: 'Value',
              type: 'custom',
              render: ({ value, onChange, label, name }) => {
                return (
                  <Input
                    labelPosition='inside-top'
                    type='text'
                    value={typeof value === 'boolean' ? '' : value}
                    label={label}
                    name={name}
                    onChange={onChange}
                    autoFocus
                    disabled={typeof value === 'boolean'}
                    endContent={
                      <Select
                        fullWidth={false}
                        style={{
                          width: 'fit-content',
                        }}
                        selected={typeof value === 'string' ? undefined : value}
                        onChange={onChange}
                        options={[
                          {
                            label: 'Text',
                            key: undefined,
                          },
                          {
                            label: 'Tick',
                            key: true,
                          },
                          {
                            label: 'Cross',
                            key: false,
                          },
                        ]}
                        popupProps={{
                          unstyledTrigger: true,
                        }}
                      />
                    }
                  />
                );
              },
            },
          },
        },
      },
    },
    cta: {
      label: 'Call to Action',
      type: 'button',
    },
  },
});
